import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Paper } from '@material-ui/core';
import {
  formatISO2DisplayDateString,
  formatISO2DisplayTimeString,
} from 'utils/dateFunctions';
import i18n from 'i18n';
import { toast } from 'react-toastify';

import './DocumentsCard.css';
import { ToastMessage } from 'components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileImage } from '@fortawesome/free-solid-svg-icons';
import MHDRequests from 'services/MHDRequests';
import { useEHRContext } from 'contexts/EHRContext';

const typeDict = {
  'SumárioAlta.v4.0': 'Sumário de Alta',
  'RegistroAtendimentoClínico.v4.1': 'Registro de Atendimento Clínico',
  'RegistroAtendimentoClínico.v4.2': 'Registro de Atendimento Clínico',
  DiagnosticReport: 'Resultado de exame',
};

export function DocumentsCard({
  date,
  occurenceDate,
  pacs,
  type,
  description,
  organizationName,
  binary,
  alias,
  auxOrganizationAliasRequest,
  setModalContent,
  contentType,
  index,
  selectedIndex,
  setSelectedIndex,
  imaging,
}) {
  const { ehrState } = useEHRContext();
  const [selected, setSelected] = useState(false);
  function handleClick() {
    try {
      setModalContent({
        link: binary,
        description,
        contentType,
        dateTime: date || 'Não encontrado',
      });
      setSelected(true);
      setSelectedIndex(index);
    } catch (err) {
      toast.error(
        <ToastMessage>Houve um problema ao carregar o documento</ToastMessage>,
      );
    }
  }

  async function openPacsViewer() {
    try {
      const viewer = await MHDRequests.getPacsViewer({
        diagnosticReportID: pacs,
        organizationId: ehrState.subject.organizationId,
        subjectToken: ehrState.subject.token,
        subjectId: ehrState.subject.id,
        subjectRole: '',
        purposeOfUse: ehrState.resource.purposeOfUse,
      });

      const width = window.innerWidth * 0.5;
      const heigth = window.innerHeight * 0.7;
      const left = (window.innerWidth - width) / 2;
      const top = window.innerHeight - heigth;

      if (viewer.address) {
        window.open(
          viewer.address,
          '_blank',
          `resizable=true, top=${top}, left=${left}, width=${width}, height=${heigth}`,
        );
      }
    } catch (err) {
      console.log(err);
    }
  }

  return (
    <Paper
      elevation={3}
      className={
        selectedIndex === index && selected
          ? 'ehrTimeline-card selected'
          : 'ehrTimeline-card'
      }
      onClick={handleClick}
      role="button"
    >
      <div className="ehrCard-header">
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
          <div style={{ display: 'flex' }}>
            <p className="ehrCard-date">
              Liberação:
              {` ${formatISO2DisplayDateString(date, i18n.language)}`}
            </p>
            <p className="ehrCard-time">
              {formatISO2DisplayTimeString(date, i18n.language).slice(0, -3)}
            </p>
          </div>
          {occurenceDate && (
            <div style={{ display: 'flex' }}>
              <p className="ehrCard-date">
                Coleta:
                {` ${formatISO2DisplayDateString(
                  occurenceDate,
                  i18n.language,
                )}`}
              </p>
              <p className="ehrCard-time">
                {formatISO2DisplayTimeString(
                  occurenceDate,
                  i18n.language,
                ).slice(0, -3)}
              </p>
            </div>
          )}
        </div>
        <p
          className={
            typeDict[type] === 'Resultado de exame'
              ? 'ehrCard-organization diagnosticReport'
              : 'ehrCard-organization'
          }
        >
          {alias || organizationName}
        </p>
      </div>
      <div style={{ marginBottom: '10px' }}>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <p className="ehrCard-docType-request">
            Solicitados ({auxOrganizationAliasRequest?.split(/[-/]/).length}
            ):
          </p>
          {auxOrganizationAliasRequest && (
            <p className="ehrCard-docType-request">
              {auxOrganizationAliasRequest}
            </p>
          )}
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            marginTop: '10px',
          }}
        >
          <p className="ehrCard-docType-request">
            Liberados ({type?.split(/[-/]/).length}
            ):
          </p>
          <p className="ehrCard-docType">{typeDict[type] || type}</p>
        </div>
      </div>
      <div className="ehrCard-title">
        <p className="ehrCard-practitioner">{description}</p>
        {imaging && (
          <button className="pacs-button" onClick={() => openPacsViewer()}>
            <FontAwesomeIcon icon={faFileImage} size="2x" />
          </button>
        )}
      </div>
    </Paper>
  );
}

DocumentsCard.propTypes = {
  date: PropTypes.string,
  occurenceDate: PropTypes.string,
  type: PropTypes.string,
  description: PropTypes.string,
  organizationName: PropTypes.string,
  alias: PropTypes.string,
  auxOrganizationAliasRequest: PropTypes.string,
  binary: PropTypes.string.isRequired,
  pacs: PropTypes.string,
  setModalContent: PropTypes.func,
  contentType: PropTypes.string,
  index: PropTypes.number,
  selectedIndex: PropTypes.number,
  setSelectedIndex: PropTypes.func,
  imaging: PropTypes.bool,
};

DocumentsCard.defaultProps = {
  date: 'Indisponível',
  occurenceDate: undefined,
  type: 'Indisponível',
  description: 'Indisponível',
  organizationName: 'Indisponível',
  alias: 'Indisponível',
  auxOrganizationAliasRequest: '',
  pacs: '',
  setModalContent: () => {},
  contentType: '',
  index: 0,
  selectedIndex: 0,
  setSelectedIndex: () => {},
  imaging: false,
};
